import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ParentDashboard } from '../../models/parent-dashboard';
import { DashboardService } from '../../services/dashboard.service';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { Banner } from '../../models/banner';
import { FirebaseAnalyticsService } from 'firebase-analytics';
import { pages } from '../../../../../utils/pages';
import { ExamTestService } from '../../../exams/services/exam-test.service';
import { OnlineMeeting } from '../../../online-meetings/models/online-meeting';
import { OnlineMeetingsService } from '../../../online-meetings/services/online-meetings.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends ComponentBase implements OnInit {

  parentDashboard: ParentDashboard;
  subscription: Subscription;
  toggle: boolean = false;
  notices: Array<Banner>;
  onlineExams: any[];
  todaysOnlineMeetings: Array<OnlineMeeting>;

  constructor(private dashboardService: DashboardService
    , private pageHeadingService: PageHeadingService
    , private firebaseAnalyticsService: FirebaseAnalyticsService
    , private examTestService: ExamTestService
    , private datePipe: DatePipe
    , private onlineMeetingService: OnlineMeetingsService) {
    super();
  }

  ngOnInit() {
    this.firebaseAnalyticsService.logPageView(pages.dashboard);
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Dashboard"));
    this.subscription = this.dashboardService.getParentDashboard()
      .subscribe((dasboard) => {
        this.parentDashboard = dasboard
        this.toggle = !this.toggle;
        this.notices = this.parentDashboard.banner.filter(o => o.message_type == 1);
      });
    this.addSubscription(this.subscription);

    let sub = this.examTestService.getUpcomingOnlineExamTests()
      .subscribe(res => {
        res.sort((a, b) => new Date(a.from_time).getTime() - new Date(b.from_time).getTime());
        this.onlineExams = res.filter(e => e.action != 3);
      });
    this.addSubscription(sub);

    let sub1 = this.onlineMeetingService.getUpcomingMeetings()
      .subscribe(res => {
        this.todaysOnlineMeetings = res['upcoming_meetings'];
        if (this.todaysOnlineMeetings.length) {
          this.todaysOnlineMeetings = this.todaysOnlineMeetings.filter(o => (new Date(o.start_time).setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0)) || (o.is_recurring && new Date(o.start_time).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0))).sort((a, b) => (this.getTimeFromDate(a.start_time) > this.getTimeFromDate(b.start_time) ? 1 : -1));
          this.todaysOnlineMeetings.forEach(meeting => {
            if (this.CanJoinMeeting(meeting)) {
              meeting.can_join = true;
            }
            else {
              meeting.can_join = false;
            }
          });
        }
      });
    this.addSubscription(sub1);
  }

  CanJoinMeeting(meeting: OnlineMeeting) {
    if (!meeting.is_recurring && new Date(meeting.start_time).getTime() <= new Date().getTime()) {
      return true;
    }
    else if (meeting.is_recurring && new Date(meeting.start_time).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)) {
      return true;
    }
    else {
      return false;
    }
  }

  getTimeFromDate(date: Date): string {
    let new_date = new Date(date);
    return this.datePipe.transform(new_date, 'HH:mm');
  }
}
